import croppie from 'croppie'

let croppiecreated = false

const convertBase64 = (file) => {

  return new Promise((resolve, reject) => {

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {

      resolve(fileReader.result);
    };

    fileReader.onerror = (error) => {

      reject(error);
    };
  });
};

(function($) {  
  
  let $shortcodeuseraccount = $('.ShortCode.UserAccount')
  if($shortcodeuseraccount.length) { 

    $shortcodeuseraccount = $shortcodeuseraccount.eq(0)

    const $updatebutton =  $shortcodeuseraccount.find('.Field.Update .Button')
    $updatebutton
    .on(
      'click',
      function(e) {

        let avatarchangedcount = 0
        let avatarchanged = false

        const $updateform = $('.UpdateForm')
        const $form = $updateform.find('.Form')
        const $results = $updateform.find('.Results')
        const $avatarformimage = $shortcodeuseraccount.find('> .Avatar img')
        const $avatarimage = $('#AcademyUpdateFormAvatar')
        const $removeuser = $updateform.find('.RemoveUser a')
        const $confirmremoveuser = $updateform.find('.ConfirmRemoveUser')
        const $confirmremoveuserpwd = $confirmremoveuser.find('.YourPassword input')
        const $confirmremoveusercancel = $confirmremoveuser.find('.Buttons .Cancel')
        const $confirmremoveuserok = $confirmremoveuser.find('.Buttons .Ok')
        const $confirmremoveusermessage = $confirmremoveuser.find('.RemoveMessage')
        const $confirmremoveuserconfirm = $confirmremoveuser.find('.RemoveConfirm button')

        let tempzoom = 0.1667

        if(!croppiecreated) { 
          
          $avatarimage.croppie()  

          setTimeout(() => {
          
            $avatarimage.croppie('setZoom', 0.1667)

          }, 400) 

          croppiecreated = true
        }
            
        $avatarimage
        .parent()
        .on(
          'update.croppie',
          function(e, data) {
            
            tempzoom = data.zoom

            if(avatarchangedcount < 4)  {

              avatarchangedcount++
              return
            }
            
            avatarchanged = true
          }
        )

        const $avatarfile = $updateform.find('#avatar')

        $avatarfile
        .on(
          'change',
          function(e) {

            convertBase64(e.target.files[0])
            .then(result => {

              avatarchanged = true

              $avatarimage.croppie(
                'bind',
                result
              )    
              
              $avatarfile.prop('value', null)         
            })
          }
        )

        const resize = () => {

          $avatarimage.croppie('setZoom', tempzoom)

          $updateform
          .dialog({
            height: Math.min(600, window.innerHeight * 0.9),
            position: {
              my: "center center",
              at: "center center",
              of: window
            }
          })            
        }

        window.addEventListener(
          'resize',
          resize
        )

        $('html').css('overflow', 'hidden')
        $('html').scrollTop(0)

        $updateform.dialog({
          autoOpen: false,
          width: '80%',
          height: 500,
          modal: true,
          resizable: false,
          title: __('Update account'),
          position: {
            my: "center center",
            at: "center center",
            of: window
          },
          buttons: [
            {
              text: __('Update'),
              class: 'Update',
              click: e => {  

                $results.html('') 

                if(avatarchanged) { 

                  $results.html(`
                    <div class="Result Warning">
                      ${ __('Updating avatar') }
                    </div>
                  `)

                  $avatarimage
                  .croppie(
                    'result',
                    {
                      type: 'blob',
                      size: 'original'   
                    }                 
                  )
                  .then(function(blob) {               

                    const data = new FormData()
                    data.append('file', blob)
                    data.append('userid', window.academystatus.userid)

                    fetch(
                      `wp-json/academy/avatar/upload`, 
                      {
                        method: 'POST',
                        headers: {
                          'X-WP-Nonce': academy_web_site.nonce
                        },
                        body: data
                      }
                    )           
                    .then(response => {

                      if(response.status != 200) {                        

                        /*
                        */
                        $results.html(`
                          <div class="Result Error">
                            ${ __('Invalid upload') }
                          </div>
                        `)

                      } else {             
                      
                        response.json()
                        .then(result => {                          

                          /*  
                          */
                          $results.html(`
                            <div class="Result Success">
                              ${ __('Avatar updated') }
                            </div>
                          `)

                          $avatarimage.croppie(
                            'bind',
                            result.file
                          ) 
                          .then(() => { 
                            
                            $avatarformimage.attr('src', result.file)                            
                            $avatarimage.croppie('setZoom', 0.1667)
                            avatarchanged = false

                          })
                        })
                      }
                    })          
                    .catch(error => { 

                      $results.html(`
                        <div class="Result Error">
                          ${ __('Invalid upload') }
                        </div>
                      `)
                    })  
                  })
                }

                const values = $form.serializeArray()

                $form
                .ajaxSubmit({
                  headers: {
                    "X-WP-Nonce": academy_web_site.nonce
                  },
                  beforeSubmit: (arr, $form, options) => {

                    const emptyvalues = values.filter(f => f.value.trim() == '')

                    if(emptyvalues.length) {

                      const emptyfieldsresult = []

                      emptyvalues
                      .forEach(value => {

                        const capname = value.name.charAt(0).toUpperCase() + value.name.slice(1)
                        
                        emptyfieldsresult.push(`<div>${ __('Please fill this field') + ': ' + __(capname) }</div>`)
                      })

                      $results.html(`
                        <div class="Result Warning">
                          ${ emptyfieldsresult.join('') }
                        </div>
                      `)

                      return false
                    }                                                                   

                    /*
                    */
                    $results.html(`
                      <div class="Result Warning">
                        ${ __('Updating data') }
                      </div>
                    `)

                    const emailfield = values.find(f => f.name == 'email')
                    const email = emailfield.value
                    const emailvalid = String(email)
                    .toLowerCase()
                    .match(
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    );

                    if(emailvalid) {

                      return true
                    }

                    /*
                    */
                    $results.html(`
                      <div class="Result Error">
                        ${ __('Invalid email') }
                      </div>
                    `)

                    return false
                  },
                  method: 'POST',
                  url: $form.attr('action'),
                  data: $form.serializeArray(),
                  success: (data) => {

                    /*
                    */
                    $results.html(data)

                    if(!data) {

                      /*
                      */
                      $results.html(`
                        <div class="Result Error">
                          ${ __('Nothing changed') }
                        </div>
                      `)
                    }

                    const fields = [
                      'Name',
                      'Surname',
                      'Email',
                      'Company',
                      'Country',
                      'Language',
                      'Industry',
                      'Newsletter'
                    ]

                    fields.forEach(fieldname => {

                      const $resultname = $results.find('.Result.Success.' + fieldname)
                      if($resultname.length) {

                        let value = $resultname.data('value')

                        if(fieldname == 'Newsletter') {

                          value = value == 'on' ? __('Yes') : __('No')
                        }

                        $('.ShortCode.UserAccount .Field.' + fieldname + ' .Value').html(__(value))                        

                        const $fieldinput = $('.UpdateForm .Form .Field.' + fieldname + ' input')

                        $fieldinput.data('value', value)
                      }
                    })
                  }
                })
              }
            },
            {
              text: __('Close'),
              click: () => {           
                
                $results.html('') 
                $updateform.dialog('close')                 

                $('html').css('overflow', 'auto')                

                const fields = [
                  'Name',
                  'Surname',
                  'Email',
                  'Company'
                ]

                fields.forEach(fieldname => {

                  const $fieldinput = $('.UpdateForm .Form .Field.' + fieldname + ' input')

                  if($fieldinput.val().trim() == '') {

                    $fieldinput.val($fieldinput.data('value'))
                  }
                }) 

                window.removeEventListener(
                  'resize',
                  resize
                )
              }
            }
          ],
          close: function() { 
            
            // $avatarimage.croppie('destroy')            
            $updateform.dialog('close') 
          }
        });
        
        $removeuser
        .on(
          'click',
          function() {
            
            $confirmremoveuser.css('display', 'flex')
          }
        )

        $confirmremoveusercancel
        .on(
          'click',
          function() {
            
            $confirmremoveuser.css('display', 'none')
            $confirmremoveuserpwd.val(null)
            $confirmremoveuserok.prop('disabled', true)
            $confirmremoveusermessage.removeClass('Info Success Error')            
            $confirmremoveusermessage.html('') 
          }
        )

        $confirmremoveuserpwd
        .on(
          'change keyup',
          function() {
            
            const $this = $(this)

            if($this.val().length > 2) {

              $confirmremoveuserok.prop('disabled', false)

            } else {

              $confirmremoveuserok.prop('disabled', true)
            }
          }
        )

        $confirmremoveuserconfirm
        .on(
          'click',
          function() {

            location.href = '/'
          }
        )

        $confirmremoveuserok
        .on(
          'click',
          function() {

            $confirmremoveuserok.prop('disabled', true)
            $confirmremoveusermessage.addClass('Info')
            $confirmremoveusermessage.html(__('Removing user...'))

            const removeurl = `/wp-json/academy/user/remove`
            const data = {
              userid: window.academystatus.userid,
              password: $confirmremoveuserpwd.val()
            }

            fetch(
              removeurl,
              {
                method: "POST",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  'X-WP-Nonce': academy_web_site.nonce
                },
                body: JSON.stringify(data)
              }
            )
            .then(response => {

              response.json()
              .then(data => {
                
                $confirmremoveusermessage.removeClass('Info Success Error') 
              
                if(data.code == 'ok') {

                  $confirmremoveusermessage.addClass('Success')
                  $confirmremoveuserconfirm.addClass('Important')

                } else {
                  
                  $confirmremoveusermessage.addClass('Error')
                }
                  
                $confirmremoveusermessage.html(data.message)
              })
            })
            .catch(function(res){
                  
              $confirmremoveusermessage.removeClass('Info')
              $confirmremoveusermessage.addClass('Error')
              
              $confirmremoveusermessage.html(res) 
            })
          }
        )

        $updateform.parent('.ui-dialog').attr('context', 'useraccount')     

        $updateform.dialog('open')

        resize()
      }
    )  
  } 

})(jQuery)